import React from 'react';

export const PatientCell: React.FC<{ name: string; mrn?: string | null }> = ({
  name,
  mrn,
}) => (
  <div className='flex flex-col'>
    <span>{name}</span>
    {mrn ? <span className='text-xs text-muted-foreground'>{mrn}</span> : null}
  </div>
);
